// Shared example layout definitions
export const exampleLayouts = [
  { 
    name: 'Example 1', 
    file: 'example1', 
    thumb: '/examples/example1.png' 
  },
  { 
    name: 'Example 2', 
    file: 'example2', 
    thumb: '/examples/example2.png' 
  },
  { 
    name: 'Example 3', 
    file: 'example3', 
    thumb: '/examples/example3.svg' 
  },
  { 
    name: 'Example 4', 
    file: 'example4', 
    thumb: '/examples/example4.svg' 
  },
  { 
    name: 'QWERTY', 
    file: 'example5', 
    thumb: '/examples/example5.png' 
  },
];